import { serverUrl } from "../config/GeneralConfig";
import { serverCall } from "../modules/ServerComms";
import Version from "../version/Version";

const getAnalyticsHost = () => {
  const isDevEnvironment = serverUrl.includes("dev");
  return isDevEnvironment ? "https://dev-api.manandvan.app" : serverUrl;
};

const ANALYTICS_HOST = getAnalyticsHost();

function analyticsCall(method, path, body, theCallback, jwt) {
  var xhr = new XMLHttpRequest();
  xhr.onreadystatechange = function () {
    if (xhr.readyState === 4) {
      var resJson;
      try { resJson = JSON.parse(xhr.responseText); } catch (e) { resJson = false; }
      theCallback(xhr.status === 0 ? 504 : xhr.status, resJson || false);
    }
  };
  xhr.open(method, ANALYTICS_HOST + path, true);
  xhr.setRequestHeader("Content-type", "application/json; charset=utf-8");
  xhr.setRequestHeader("Authorization", "Bearer " + jwt);
  xhr.setRequestHeader("ClientType", Version.ClientType);
  xhr.setRequestHeader("AppVersion", Version.AppVersion);
  xhr.send(body ? JSON.stringify(body) : null);
}

function getMonthlyRpt(queryParams, theCallback, theJWTToken) {
  const { theYear, userType } = queryParams;
  const url = `/api/admin/monthlyReport?userType=${userType}&year=${theYear}`;

  const handleCallAPI = (resStatus, resJson) => {
    var responseString;

    if (resStatus == "400" || resStatus == 400) {
      // jobsfound | nouserdata nouserwiththatemail unauthorised nojobsfound usernotactive

      if (resJson.errorString == "nouserdata") {
        responseString = "ERROR: NO USER DATA";
      } else if (resJson.errorString == "nouserwiththatemail") {
        responseString = "ERROR: USER NOT FOUND";
      } else if (resJson.errorString == "usernotactive") {
        responseString = "ERROR: USER NOT ACTIVE";
      } else if (resJson.errorString == "unauthorised") {
        responseString = "ERROR: USER NOT AUTHORISED";
      } else if (resJson.errorString == "nojobsfound") {
        responseString = "ERROR: NO JOBS FOUND";
      } else if (resJson.errorString == "invalidfilter") {
        responseString = "ERROR: INVALID FILTER";
      } else if (resJson.errorString == "invalidsearch") {
        responseString = "ERROR: INVALID SEARCH";
      } else if (resJson.errorString == "invalidsorts") {
        responseString = "ERROR: INVALID SORT";
      } else if (resJson.errorString == "invalidpage") {
        responseString = "ERROR: INVALID PAGE";
      } else {
        responseString = "ERROR: UNKNOWN";
      }

      return theCallback(resStatus, responseString, resJson);
    } else if (resStatus == "401" || resStatus == 401) {
      if (resJson.errorString == "unauthorised") {
        responseString = "ERROR: USER NOT AUTHORISED";
      } else if (resJson.errorString == "userblocked") {
        responseString = "ERROR: USER BLOCKED";
      } else if (resJson.errorString == "outdatedappversion") {
        responseString = "ERROR: OUTDATED VERSION";
      } else {
        responseString = "ERROR: UNKNOWN";
      }

      return theCallback(resStatus, responseString, resJson);
    } else if (
      resStatus == "504" ||
      resStatus == 504 ||
      resStatus == "502" ||
      resStatus == 502
    ) {
      responseString = "ERROR: TIMEOUT";
      return theCallback(resStatus, responseString, false);
    } else if (resStatus == "200" || resStatus == 200) {
      if (resJson.successString == "usersfound") {
      }

      return theCallback(resStatus, responseString, resJson);
    }
  };
  serverCall("GET", url, null, handleCallAPI, theJWTToken);
}

const BASE = "/api/admin/analytics";

const handleAnalyticsResponse = (theCallback) => (resStatus, resJson) => {
  const status = Number(resStatus);

  if (status === 200 || status === 202) {
    return theCallback(status, null, resJson);
  }
  if (status === 502 || status === 504 || status === 0) {
    return theCallback(504, "Request timed out. Please try again.", false);
  }
  return theCallback(
    status,
    (resJson && resJson.message) || "Something went wrong. Please try again.",
    resJson
  );
};

function getAnalyticsSummary(period, theCallback, theJWTToken) {
  analyticsCall("GET", `${BASE}/summary?period=${period}`, null, handleAnalyticsResponse(theCallback), theJWTToken);
}

function refreshAnalytics(period, theCallback, theJWTToken) {
  analyticsCall("POST", `${BASE}/refresh`, { period }, handleAnalyticsResponse(theCallback), theJWTToken);
}

function getAnalyticsJob(jobId, theCallback, theJWTToken) {
  analyticsCall("GET", `${BASE}/jobs/${encodeURIComponent(jobId)}`, null, handleAnalyticsResponse(theCallback), theJWTToken);
}

function getAnalyticsSnapshot(shortId, theCallback, theJWTToken) {
  analyticsCall("GET", `${BASE}/snapshot/${encodeURIComponent(shortId)}`, null, handleAnalyticsResponse(theCallback), theJWTToken);
}

function getAnalyticsHealth(theCallback, theJWTToken) {
  analyticsCall("GET", `${BASE}/health`, null, handleAnalyticsResponse(theCallback), theJWTToken);
}

export {
  getMonthlyRpt,
  getAnalyticsSummary,
  refreshAnalytics,
  getAnalyticsJob,
  getAnalyticsSnapshot,
  getAnalyticsHealth,
};
